import Component from '../component';

export default class RemoteReloadingElement extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$successElement = this.$element.find(
      '.remoteReloadingElement-success'
    );
    this.$errorElement = this.$element.find('.remoteReloadingElement-error');

    this.bindEvents();
  }

  bindEvents() {
    this.handleAJAXSuccess = this.handleAJAXSuccess.bind(this);
    this.handleAJAXError = this.handleAJAXError.bind(this);

    this.$element.on(
      'ajax:success.RemoteReloadingElement',
      this.handleAJAXSuccess
    );
    this.$element.on('ajax:error.RemoteReloadingElement', this.handleAJAXError);
  }

  unbindEvents() {
    this.$element.off(
      'ajax:success.RemoteReloadingElement',
      this.handleAJAXSuccess
    );
    this.$element.off(
      'ajax:error.RemoteReloadingElement',
      this.handleAJAXError
    );
  }

  handleAJAXSuccess() {
    if (this.$successElement.length) {
      return this.$successElement.show();
    }

    window.Turbolinks.reload({keepScrollPosition: true});
  }

  handleAJAXError(_, data) {
    if (this.$errorElement.length) {
      return this.$errorElement.show();
    }

    if (data.status && this.$element.data(data.status.toString())) {
      window.Turbolinks.visit(this.$element.data(data.status.toString()));
    } else {
      window.Turbolinks.reload({keepScrollPosition: true});
    }
  }
}
